import store from 'Store';
import CONFIG from 'Config';
import { clearObject } from 'Utils/common';
import * as EVENTS from './events';
import {
  getParams,
  getSignUpParams,
  getSignUpSocialParams,
  getProfileParams,
} from './params';

function triggerEvent(event, data = {}) {
  let params = getParams(event, data);
  if (window.location.pathname.startsWith('/profile')) {
    Object.assign(params, getProfileParams());
  }
  params = clearObject(params);
  (window.dataLayer || []).push({ event, ...params, ...data });
}

function triggerSignUpStep(stepNumber, signUpData) {
  const params = getSignUpParams(stepNumber, signUpData);
  triggerEvent(EVENTS.SIGN_UP, params);
}

function triggerSignUpSocialStep(stepNumber, signUpData) {
  const params = getSignUpSocialParams(stepNumber, signUpData);
  triggerEvent(EVENTS.SIGN_UP, params);
}

function triggerAccountCreated(data = {}) {
  triggerEvent(EVENTS.ACCOUNT_CREATED, data);
}

function triggerPageResolved() {
  triggerEvent(EVENTS.PAGE_RESOLVED);
}

function triggerPageView() {
  triggerEvent(EVENTS.PAGE_VIEW);
}

function triggerNewInvestment() {
  triggerEvent(EVENTS.COMPLETED_INVESTMENT);
}

function triggerNewPledge() {
  triggerEvent(EVENTS.COMPLETED_PLEDGE);
}

function triggerLinkedBankAccount(data) {
  triggerEvent(EVENTS.LINKED_BANK_ACCOUNT, data);
}

function triggerAccreditedAndLinkedBankAccount() {
  triggerEvent(EVENTS.ACCREDITED_AND_LINKED_BANK_ACCOUNT);
}

function triggerAccreditationAfterRegister() {
  triggerEvent(EVENTS.ACCREDITATION_AFTER_REGISTER);
}

function triggerAccreditedOnce() {
  triggerEvent(EVENTS.ACCREDITED_ONCE);
}

function triggerPersonVerified() {
  triggerEvent(EVENTS.VERIFIED_PERSON);
}

function triggerExplainerWatchStart() {
  triggerEvent(EVENTS.EXPLAINER_WATCH_START);
}

function triggerExplainerWatchEnd(data) {
  triggerEvent(EVENTS.EXPLAINER_WATCH_END, data);
}

function triggerHSFormSubmit(formIdentification) {
  triggerEvent(EVENTS.HUBSPOT_FORM_SUBMIT, formIdentification);
}

function triggerHSPageView(route) {
  const _hsq = window._hsq || [];
  if (store.getters['login/isLoggedIn']) {
    const { email } = store.getters['profile/profile'];
    _hsq.push(['identify', { email }]);
  } else {
    _hsq.push(['identify']);
  }
  _hsq.push(['setPath', route.fullPath]);
  _hsq.push(['trackPageView']);
}

function triggerSiftPageView() {
  const _sift = window._sift = window._sift || []; // eslint-disable-line
  _sift.push(['_setAccount', CONFIG.siftAccount]);
  if (store.getters['login/isLoggedIn']) {
    const { email } = store.getters['profile/profile'];
    _sift.push(['_setUserId', email]);
  }
  _sift.push(['_trackPageview']);
}

function onPageResolved(route) {
  setTimeout(triggerPageResolved);
  setTimeout(() => {
    triggerPageView();
    triggerSiftPageView();
    triggerHSPageView(route);
  }, 1500);
}

export default {
  EVENTS,
  onPageResolved,
  triggerSignUpStep,
  triggerSignUpSocialStep,
  triggerAccountCreated,
  triggerHSFormSubmit,
  triggerEvent,
  triggerLinkedBankAccount,
  triggerNewPledge,
  triggerNewInvestment,
  triggerAccreditedAndLinkedBankAccount,
  triggerAccreditationAfterRegister,
  triggerAccreditedOnce,
  triggerPersonVerified,
  triggerExplainerWatchStart,
  triggerExplainerWatchEnd,
};
